<template>
  <div class="hud" v-if="route !== '/spaceship' && route !== '/passworld' && !$store.getters.isFocusedOnStuff">
    <div class="content">
      <p>
        <span v-if="!isMobile">{{ storedPlace }} </span>
        <span
          class="back"
          @click="$router.go(-1)"
          v-if="
            route !== '/passworld' &&
              route !== '/main-hall' &&
              route !== '/spaceship'
          "
          >| GO BACK</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import MainMixinVue from "./MainMixin.vue";
export default {
  name: "HUD",
  mixins: [MainMixinVue],
  data() {
    return {};
  },
  computed: {
    storedPlace() {
      return this.$store.getters.toPlace;
    },
    route() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.hud {
  position: fixed;
  text-align: center;
  top: 1vh;
  left: 50%;
  width: max-content;
  z-index: 2;
}

.content {
  position: relative;
  background-color: rgba(0, 0, 0, 0.3);
  width: 50vw;
  height: 7vh;
  border-radius: 25px;
  left: -50%;
  font-size: 5vh;

  p {
    margin: 0;
    padding: 5px;
    font-size: 5vh;
  }

  .back {
    &:hover,
    &:focus {
      background: $grey;
      color: $blue;
    }
  }
}

@media screen and (max-width: 750px) {
  p {
    font-size: 7vh;
  }
  .content {
    height: 10vh;
    width: max-content;
    padding-left: 2vw;
    padding-right: 2vw;
  }
}
</style>
